export default __webpack_public_path__ + "static/media/lotus-position.7361b195.png";